/**
 * Mutations GraphQL AppSync.
 * Copiate verbatim da `enermed-app/aws-utils/queriesContratto.js`.
 */

export const SET_BOLLETTA_VISTA = /* GraphQL */ `
  mutation setBollettaVista(
    $codice_cliente: String!
    $codice_contratto: String!
    $invoice: String!
  ) {
    setBollettaVista(
      codice_cliente: $codice_cliente
      codice_contratto: $codice_contratto
      invoice: $invoice
    )
  }
`

export const SEND_AUTOLETTURA = /* GraphQL */ `
  mutation sendAutoLettura(
    $codice_cliente: String!
    $codice_contratto: String!
    $data_misura: AWSDate!
    $F1: Float!
    $F2: Float!
    $F3: Float!
  ) {
    sendAutoLettura(
      codice_cliente: $codice_cliente
      codice_contratto: $codice_contratto
      data_misura: $data_misura
      F1: $F1
      F2: $F2
      F3: $F3
    )
  }
`

export const UPDATE_CLIENTE = /* GraphQL */ `
  mutation updateCliente($codice_cliente: String!, $vals: ClienteUpdate) {
    updateCliente(codice_cliente: $codice_cliente, vals: $vals)
  }
`

export const UPDATE_SOGLIA_SPESA = /* GraphQL */ `
  mutation updateSogliaSpesa($codice_contratto: String!, $soglia_spesa: Float!) {
    updateSogliaSpesa(codice_contratto: $codice_contratto, soglia_spesa: $soglia_spesa)
  }
`

export const UPDATE_ETICHETTA_POD = /* GraphQL */ `
  mutation updateEtichettaPod($codice_pod: String!, $etichetta: String) {
    updateEtichettaPod(codice_pod: $codice_pod, etichetta: $etichetta)
  }
`

export const MARK_MESSAGGIO_AS_READ = /* GraphQL */ `
  mutation markMessaggioAsRead($codice_cliente: String!, $datetime: String!) {
    markMessaggioAsRead(codice_cliente: $codice_cliente, datetime: $datetime)
  }
`
